import React from 'react';
import { Feature, IActionPointInfo } from '@tencent/workbench';
import { FontFamilyFeature as ToolbarFontFamilyFeature } from '@src/framework/workbench/ui/font-family/font-family-feature';
import FontDropdown from '@framework/workbench/drawer/components/dropdown/font-dropdown';
import { FORM_CONFIGS } from '@framework/workbench/drawer/ui/text/font/font-family/config';
import { getFontFamilyConfigData } from '@src/framework/editor/src/js/constants/toolbar-data';
import i18n from '@i18next/i18n';
import { IChartModel } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-model.interface';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { getTitleStyle, updateTitleStyle } from '@framework/workbench/drawer/ui/chart/common/font/util/title';
import { IChartTextProperty } from '@src/slide/domain/ui-model/element-modeles/property/chart/chart-shape-property.interface';
import { ChartElementType } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-interaction.interface';
import { ChartActionType } from '@src/slide/domain/ui-model/element-modeles/property/chart/constant';

@Feature()
export class ChartFontFamilyFeature extends ToolbarFontFamilyFeature {
    public getFontFamily(): string {
        const model = this.getSelectModel() as IChartModel;
        if (!model || model.type !== UIModelType.CHART || !model.selectedElement) return '';
        const selecetdElementType = model.selectedElement.type;
        if (selecetdElementType === ChartElementType.TITLE) {
            return this.getTitleFontFamily(model);
        }
        const element = model.getSelectedElementProperty() as IChartTextProperty;
        if (!element) return '';
        return element.getTextFontFamily();
    }

    public getFontFamilyName(): string {
        const fontFamilyList = getFontFamilyConfigData();
        const font = this.getFontFamily();
        if (font === 'multi') return i18n.t('多种字体');
        if (font === '默认字体' || !font) return i18n.t('默认字体');
        return fontFamilyList.find(item => item.id === font)?.content || font;
    }

    public onFontChange(fontFamily: string): void {
        const model = this.getSelectModel() as IChartModel;
        if (!model || model.type !== UIModelType.CHART || !model.selectedElement) return;
        const selecetdElementType = model.selectedElement.type;
        if (selecetdElementType === ChartElementType.TITLE) {
            return this.updateTitleFontFamily(model, fontFamily);
        }
        const element = model.getSelectedElementProperty() as IChartTextProperty;
        return element.updateFontStyle(ChartActionType.FONTFAMILY, fontFamily);
    }

    public renderFontFamily(info: IActionPointInfo) {
        return <FontDropdown
            text={this.getFontFamilyName()}
            dropContent={this.renderSelectList(true)}
            style={{ width: 160, paddingLeft: 6 }}
            tooltip={FORM_CONFIGS[0].tooltip}
        />;
    }

    private getTitleFontFamily(model: IChartModel) {
        return getTitleStyle(model, ChartActionType.FONTFAMILY);
    }

    private updateTitleFontFamily(model: IChartModel, fontFamily: string) {
        updateTitleStyle(model, ChartActionType.FONTFAMILY, fontFamily);
    }
}
